
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'POP_QStagingEvaluationIndicatorPointForPelvicOrganProlapse',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/POP_QStagingEvaluationIndicatorPointForPelvicOrganProlapse.vue